import script from "./UserGroupCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGroupCardModal.vue?vue&type=script&setup=true&lang=js"

import "./UserGroupCardModal.vue?vue&type=style&index=0&id=717bdcd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717bdcd2"]])

export default __exports__